

import { useState, useEffect } from 'react';
import { playIcon, playPause } from '../utils/icons';

import Description from './Child/Description';
import SinglePlayer from './Child/SinglePlayer';
import Title from './Child/Title';
import LoadMore from './LoadMore';

const Playlist = ({ attributes, videos, callVideos, nextPageToken }) => {

    const { player, desc, configure } = attributes;
    const [videoId, setVideoId] = useState(null);
    const { perPage } = configure;

    useEffect(() => {
        setVideoId(videos[0].id);
    }, [])

    return <div className='playlistContainer'>
        <div className="player">
            <SinglePlayer videoId={videoId} player={player} />
        </div>
        <div className="playlist">
            {videos.map((videoItem, index) => {
                const { id, snippet } = videoItem;
                const { title, description, thumbnails } = snippet;
                const { medium } = thumbnails;

                return <div className='singleItem' key={index}>
                    <div className="img" onClick={() => setVideoId(id)}>
                        <img src={medium?.url} alt={title || ''} />
                        {(videoId === id) ? <div className='playIcon'>{playPause}</div>
                            : <div className="playIcon">
                                {playIcon}
                            </div>}
                    </div>
                    <div className="info">
                        <Title title={title} videoId={id} attributes={attributes} />
                        <Description description={description} desc={desc} />
                    </div>

                </div>
            })}

            {(perPage <= videos.length && nextPageToken) && (<LoadMore callVideos={callVideos} />)}
        </div>

    </div>
}
export default Playlist;